/** זיהוי פלטפורמה למסך ההתקנה. לא מחליף בדיקה בטלפונים אמיתיים. */
export type Platform = 'ios-safari' | 'ios-other' | 'android' | 'desktop';

export function detectPlatform(ua = navigator.userAgent): Platform {
  const isIOS = /iPad|iPhone|iPod/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
  if (isIOS) {
    const isSafari = /Safari/.test(ua) && !/CriOS|FxiOS|EdgiOS|OPiOS/.test(ua);
    return isSafari ? 'ios-safari' : 'ios-other';
  }
  if (/Android/.test(ua)) return 'android';
  return 'desktop';
}

/** האפליקציה כבר מותקנת ונפתחת במסך מלא. */
export function isStandalone(): boolean {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    ('standalone' in navigator && (navigator as { standalone?: boolean }).standalone === true)
  );
}
